import React, { Component, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import Layout from './hoc/Layout/Layout';
import BurgerBuilder from './containers/BurgerBuilder/BurgerBuilder';
import Checkout from './containers/Checkout/Checkout';
import Orders from './containers/Orders/Orders';
// import Auth from './containers/Auth/Auth';
import Logout from './containers/Auth/Logout/Logout';
import * as actions from './store/actions/index';

const Auth = React.lazy(() => import('./containers/Auth/Auth'));

class App extends Component {
	componentDidMount() {
		this.props.onTryAutoSignIn();
	}

	render() {
		let routes = (
			<Switch>
				<Route
					path="/user/signin"
					render={() => (
						<Suspense fallback={<div>Loading...</div>}>
							<Auth />
						</Suspense>
					)}
				/>
				<Route path="/" component={BurgerBuilder} />
			</Switch>
		);

		if (this.props.isAuthenticated) {
			routes = (
				<Switch>
					<Route
						path="/user/signin"
						render={() => (
							<Suspense fallback={<div>Loading...</div>}>
								<Auth />
							</Suspense>
						)}
					/>
					<Route path="/orders" component={Orders} />
					<Route path="/checkout" component={Checkout} />
					<Route path="/logout" component={Logout} />
					<Route path="/" component={BurgerBuilder} />
				</Switch>
			);
		}

		return (
			<div>
				<Layout>{routes}</Layout>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.token !== null,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onTryAutoSignIn: () => dispatch(actions.authCheckState()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
